import {AfterViewInit, Component, ElementRef, HostBinding, OnInit, ViewChild} from '@angular/core';
import {SplashScreenService} from '../../services/splash-screen.service';

@Component({
    selector: 'app-splash-screen',
    templateUrl: './splash-screen.component.html',
    styleUrls: ['./splash-screen.component.scss']
})
export class SplashScreenComponent implements OnInit, AfterViewInit {

    @HostBinding('style') style: any;
    @HostBinding('class') classes: any = '';

    @ViewChild('splashScreen', {read: ElementRef, static: true})
    splashScreen: ElementRef;
    splashScreenImage: string;

    constructor(private splashScreenService: SplashScreenService) {
        this.splashScreenImage = './assets/base/images/logos/logo_large.png';
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        if (this.splashScreen) {
            this.splashScreenService.init(this.splashScreen.nativeElement);
        }
    }

}
